"use strict";

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _ref;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTypes = exports.FormContainerTypes = exports.UtFormFieldPropTypes = exports.metaPropTypes = exports.inputPropTypes = void 0;

var _propTypes = require("prop-types");

var FORMS = _interopRequireWildcard(require("../constants/fieldTypes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var inputPropTypes = (0, _propTypes.shape)({
  name: _propTypes.string.isRequired,
  onBlur: _propTypes.func.isRequired,
  onChange: _propTypes.func.isRequired,
  onDragStart: _propTypes.func.isRequired,
  onDrop: _propTypes.func.isRequired,
  onFocus: _propTypes.func.isRequired,
  value: _propTypes.string.isRequired
});
exports.inputPropTypes = inputPropTypes;
var metaPropTypes = (0, _propTypes.shape)({
  active: _propTypes.bool.isRequired,
  asyncValidating: _propTypes.bool.isRequired,
  autofilled: _propTypes.bool.isRequired,
  dirty: _propTypes.bool.isRequired,
  dispatch: _propTypes.func.isRequired,
  form: _propTypes.string.isRequired,
  invalid: _propTypes.bool.isRequired,
  pristine: _propTypes.bool.isRequired,
  submitFailed: _propTypes.bool.isRequired,
  submitting: _propTypes.bool.isRequired,
  touched: _propTypes.bool.isRequired,
  valid: _propTypes.bool.isRequired,
  visited: _propTypes.bool.isRequired
});
exports.metaPropTypes = metaPropTypes;
var UtFormFieldPropTypes = {
  field: (0, _propTypes.shape)({
    type: _propTypes.string.isRequired,
    key: _propTypes.string.isRequired,
    title: _propTypes.string,
    field_options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      name: _propTypes.string.isRequired,
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired
    })),
    description: _propTypes.string,
    visibility_parent_field_key_id: _propTypes.number,
    visibility_parent_field_option_value_id: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.arrayOf)(_propTypes.number)]),
    parent_field_option_id: _propTypes.number,
    read_only: _propTypes.bool,
    default_value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number])
  }).isRequired,
  formAccount: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  input: inputPropTypes,
  meta: metaPropTypes,
  selectedOptionIds: _propTypes.any,
  // eslint-disable-line react/forbid-prop-types
  useModal: _propTypes.bool,
  isPublic: _propTypes.bool
};
exports.UtFormFieldPropTypes = UtFormFieldPropTypes;
var defaultMessagesTypes = (0, _propTypes.shape)({
  logicValidation: _propTypes.string.isRequired,
  required: _propTypes.string.isRequired,
  creditCardErrorMessages: (0, _propTypes.shape)({
    cardNumberRequired: _propTypes.string.isRequired,
    invalidCardNumber: _propTypes.string.isRequired,
    holderNameRequired: _propTypes.string.isRequired,
    expiresRequired: _propTypes.string.isRequired,
    invalidExpires: _propTypes.string.isRequired,
    securityCodeRequired: _propTypes.string.isRequired
  }),
  invalidEmail: _propTypes.string.isRequired,
  invalidCard: _propTypes.string,
  invalidFormat: _propTypes.string.isRequired
});
var mapFieldConfigTypes = (0, _propTypes.shape)({
  useGeolocation: _propTypes.bool,
  defaultCoordinates: (0, _propTypes.shape)({
    latitude: _propTypes.number,
    longitude: _propTypes.number
  })
});
var formClassesTypes = (0, _propTypes.shape)({
  formContainer: _propTypes.string,
  formTitle: _propTypes.string,
  fieldRowContainer: _propTypes.string
});
var fieldClassesTypes = (0, _propTypes.shape)({
  container: _propTypes.string,
  comment: _propTypes.string,
  error: _propTypes.string,
  title: _propTypes.string
});
var accountTypes = (0, _propTypes.shape)({
  id: _propTypes.string.isRequired,
  latitude: _propTypes.string,
  longitude: _propTypes.string
});
var componetType = (0, _propTypes.oneOfType)([_propTypes.element, _propTypes.node, _propTypes.func, _propTypes.any]);
var componentsTypes = (0, _propTypes.shape)((_ref = {}, _defineProperty(_ref, FORMS.FIELD_TEXT, componetType), _defineProperty(_ref, FORMS.FIELD_LABEL, componetType), _defineProperty(_ref, FORMS.FIELD_ANIMATED_CREDIT_CARD, componetType), _defineProperty(_ref, FORMS.FIELD_SELECT, componetType), _defineProperty(_ref, FORMS.FIELD_SWITCH, componetType), _defineProperty(_ref, FORMS.FIELD_EMAIL, componetType), _defineProperty(_ref, FORMS.FIELD_PHONE, componetType), _defineProperty(_ref, FORMS.FIELD_PASSWORD, componetType), _defineProperty(_ref, FORMS.FIELD_DATE, componetType), _defineProperty(_ref, FORMS.FIELD_TEXT_AREA, componetType), _defineProperty(_ref, FORMS.FIELD_RATING_STAR, componetType), _defineProperty(_ref, FORMS.FIELD_IMAGE, componetType), _defineProperty(_ref, FORMS.FIELD_IMAGE_RADIO, componetType), _defineProperty(_ref, FORMS.FIELD_CUIT, componetType), _defineProperty(_ref, FORMS.FIELD_CHIP, componetType), _defineProperty(_ref, FORMS.FIELD_ATTACHMENT, componetType), _defineProperty(_ref, FORMS.FIELD_PDF, componetType), _defineProperty(_ref, FORMS.FIELD_RADIO, componetType), _defineProperty(_ref, FORMS.FIELD_MAP, componetType), _defineProperty(_ref, FORMS.FIELD_CHECKBOX, componetType), _defineProperty(_ref, FORMS.FIELD_CREDIT_CARD, componetType), _defineProperty(_ref, FORMS.FIELD_CAPTCHA, componetType), _defineProperty(_ref, FORMS.FIELD_CHECKLIST, componetType), _defineProperty(_ref, FORMS.FIELD_SKETCH, componetType), _defineProperty(_ref, FORMS.FIELD_AUTOCOMPLETE, componetType), _ref));
var FormContainerTypes = {
  showTitle: _propTypes.bool,
  formClasses: formClassesTypes,
  fieldClasses: fieldClassesTypes,
  account: accountTypes,
  formStructure: (0, _propTypes.shape)({}),
  defaultMessages: defaultMessagesTypes,
  mapFieldConfig: mapFieldConfigTypes,
  fieldValues: (0, _propTypes.shape)({}),
  components: componentsTypes,
  onValuesChange: _propTypes.func,
  disableAllFields: _propTypes.bool,
  useEditableKey: _propTypes.bool
};
exports.FormContainerTypes = FormContainerTypes;
var FormTypes = {
  disableAllFields: _propTypes.bool,
  showTitle: _propTypes.bool,
  formClasses: formClassesTypes,
  fieldClasses: fieldClassesTypes,
  account: accountTypes,
  formVisibility: (0, _propTypes.shape)({}),
  formStructure: (0, _propTypes.shape)({}),
  defaultMessages: defaultMessagesTypes,
  mapFieldConfig: mapFieldConfigTypes,
  components: componentsTypes,
  FeedbackIcon: _propTypes.node,
  fieldTypeProps: (0, _propTypes.shape)({}),
  useEditableKey: _propTypes.bool
};
exports.FormTypes = FormTypes;